(function ($) {
	class WordSlider {
		constructor(element) {
			this.element = $(element);
			this.init();
		}

		init() {
			this.items = $('.word-slider-item', this.element);
			this.current = 0;
			this.total = this.items.length;
			this.interval = 3000;

			this.items.eq(this.current).addClass('is-active');
			this.element.width(this.items.eq(this.current).width());

			if (this.items.length > 1) {
				this.start();
			}

			$(window).on('resize', () => {
				this.element.width(this.items.eq(this.current).width());
			});
		}

		start() {
			this.timer = setInterval(() => this.next(), this.interval);
		}

		stop() {
			clearInterval(this.timer);
		}

		next() {
			this.items.eq(this.current).removeClass('is-active');
			this.current = this.current < this.total - 1 ? this.current + 1 : 0;
			this.items.eq(this.current).addClass('is-active');
			this.element.width(this.items.eq(this.current).width());
		}
	}

	$('.word-slider').each((i, el) => new WordSlider(el));
})(jQuery);